import PageContainer from '@/common/components/PageContainer'
import { PermissionType } from '@/common/types'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import SmsAutoLogsListing from '@/modules/transaction/components/SmsAutoLogsListing'

function SmsAutoLogsPage() {
	return (
		<PageContainer>
			<div className="flex-1 space-y-4">
				<SmsAutoLogsListing />
			</div>
		</PageContainer>
	)
}

const GuardedSmsAutoLogsPage = withUserPermission(SmsAutoLogsPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_BANK_TRANSACTION],
})

export default GuardedSmsAutoLogsPage
